// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__yKAQ9","title":"styles_title__ULLsv","blurb":"styles_blurb__Z7Kdl"};